import React, { createElement } from 'react';
import Str from '../../../helpers/Str';
import { IconBaseProps, IconType } from 'react-icons/lib';

export interface IconButtonProps {
  icon: IconType;
  className?: string;
  title?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export default function IconButton({
  icon,
  className,
  disabled,
  ...rest
}: IconButtonProps) {
  const MIcon = (props: IconBaseProps) => {
    return createElement(icon, props);
  };

  return (
    <button
      {...rest}
      disabled={disabled}
      className={Str.tw(
        className,
        'p-3 rounded-full transition',
        disabled ? 'opacity-40 cursor-not-allowed' : 'hover:bg-light-dark'
      )}
    >
      <MIcon />
    </button>
  );
}